import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/VendorReqs/VendorReqs'

function* getVendorCategories(action) {
    try {
        const result = yield call(req.getVendorCategoriesReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_CATEGORIES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_CATEGORIES_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_CATEGORIES_FAILURE, message: e?.message });
    }
}

function* createVendorCategory(action) {
    try {
        const result = yield call(req.createVendorCategoryReq, action);
        console.log('createVendorCategory result', result)
        if (result.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_CATEGORY_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_CATEGORY_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_CREATE_VENDOR_CATEGORY_FAILURE, message: e?.message });
    }
}

function* updateVendorCategory(action) {
    try {
        const result = yield call(req.updateVendorCategoryReq, action);
        console.log('updateVendorCategory result', result)
        if (result.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_CATEGORY_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_CATEGORY_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_UPDATE_VENDOR_CATEGORY_FAILURE, message: e?.message });
    }
}

function* deleteVendorCategory(action) {
    try {
        const result = yield call(req.deleteVendorCategoryReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_CATEGORY_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_CATEGORY_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_DELETE_VENDOR_CATEGORY_FAILURE, message: e?.message });
    }
}

function* createVendor(action) {
    try {
        const result = yield call(req.createVendorReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_CREATE_VENDOR_FAILURE, message: e?.message });
    }
}

function* getVendorDetails(action) {
    try {
        const result = yield call(req.getVendorDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_DETAILS_FAILURE, message: e?.message });
    }
}

function* getVendorsList(action) {
    try {
        const result = yield call(req.getVendorsListReq, action);
        if (result.success === true) {
            yield put({
                type: types.SOCIETY_GET_VENDORS_LIST_SUCCESS,
                payload: { data: result.data, meta: result.meta },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDORS_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDORS_LIST_FAILURE, message: e?.message });
    }
}

function* updateVendor(action) {
    try {
        const result = yield call(req.updateVendorReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_UPDATE_VENDOR_FAILURE, message: e?.message });
    }
}

function* deleteVendor(action) {
    try {
        const result = yield call(req.deleteVendorReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_DELETE_VENDOR_FAILURE, message: e?.message });
    }
}

function* getAllVendors(action) {
    try {
        const result = yield call(req.getAllVendorsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_ALL_VENDORS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_ALL_VENDORS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_ALL_VENDORS_FAILURE, message: e?.message });
    }
}

// ============ VENDOR SETTING ============

function* getVendorSetting(action) {
    try {
        const result = yield call(req.getVendorSettingReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_SETTING_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_SETTING_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_SETTING_FAILURE, message: e?.message });
    }
}

// ============ VENDOR TARIFFS ============

function* getVendorTariffs(action) {
    try {
        const result = yield call(req.getVendorTariffsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_TARIFFS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_TARIFFS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_TARIFFS_FAILURE, message: e?.message });
    }
}

function* createVendorTariff(action) {
    try {
        const result = yield call(req.createVendorTariffReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_TARIFF_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_TARIFF_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_CREATE_VENDOR_TARIFF_FAILURE, message: e?.message });
    }
}

function* deleteVendorTariff(action) {
    try {
        const result = yield call(req.deleteVendorTariffReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_TARIFF_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_TARIFF_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_DELETE_VENDOR_TARIFF_FAILURE, message: e?.message });
    }
}

function* getAllVendorTariffs(action) {
    try {
        const result = yield call(req.getAllVendorTariffsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_ALL_VENDOR_TARIFFS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_ALL_VENDOR_TARIFFS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_ALL_VENDOR_TARIFFS_FAILURE, message: e?.message });
    }
}

// ============ VENDOR BILLS ============

function* getVendorBillsList(action) {
    try {
        const result = yield call(req.getVendorBillsListReq, action);
        if (result.success === true) {
            // Forward BOTH the row data and the meta so the reducer can build
            // pagination — previous code dropped meta so paginators showed 0.
            yield put({
                type: types.SOCIETY_GET_VENDOR_BILLS_LIST_SUCCESS,
                payload: { data: result.data, meta: result.meta },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_BILLS_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_BILLS_LIST_FAILURE, message: e?.message });
    }
}

function* getVendorBillDetails(action) {
    try {
        const result = yield call(req.getVendorBillDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_BILL_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_BILL_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_BILL_DETAILS_FAILURE, message: e?.message });
    }
}

function* createVendorBill(action) {
    try {
        const result = yield call(req.createVendorBillReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_BILL_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_BILL_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_CREATE_VENDOR_BILL_FAILURE, message: e?.message });
    }
}

function* createVendorBillsBatch(action) {
    const created = [];
    const failed = [];
    try {
        const bills = action.data?.bills || [];
        for (let index = 0; index < bills.length; index += 1) {
            const bill = bills[index];
            try {
                const result = yield call(req.createVendorBillReq, {
                    data: { ...bill.payload, silent: true }
                });
                if (result?.success === true) {
                    created.push({
                        id: bill.id,
                        bill_number: bill.billNumber,
                        vendor: bill.vendorName,
                        status: bill.isDraft ? 'Draft' : 'Posted'
                    });
                } else {
                    failed.push({
                        id: bill.id,
                        bill_number: bill.billNumber,
                        vendor: bill.vendorName,
                        error: result?.response?.data?.message || result?.message || 'Bill could not be created'
                    });
                }
            } catch (error) {
                failed.push({
                    id: bill.id,
                    bill_number: bill.billNumber,
                    vendor: bill.vendorName,
                    error: error?.response?.data?.message || error?.message || 'Bill could not be created'
                });
            }
        }

        const result = { total: bills.length, created, failed };
        yield put({ type: types.SOCIETY_CREATE_VENDOR_BILLS_BATCH_SUCCESS, payload: result });
        action.data?.onSuccess?.(result);
    } catch (error) {
        const message = error?.message || 'Unable to create vendor bills';
        yield put({ type: types.SOCIETY_CREATE_VENDOR_BILLS_BATCH_FAILURE, message });
        action.data?.onError?.(error);
    }
}

function* updateVendorBill(action) {
    try {
        const result = yield call(req.updateVendorBillReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_BILL_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_BILL_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_UPDATE_VENDOR_BILL_FAILURE, message: e?.message });
    }
}

function* deleteVendorBill(action) {
    try {
        const result = yield call(req.deleteVendorBillReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_BILL_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_BILL_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_DELETE_VENDOR_BILL_FAILURE, message: e?.message });
    }
}

function* approveVendorBill(action) {
    try {
        const result = yield call(req.approveVendorBillReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_APPROVE_VENDOR_BILL_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_APPROVE_VENDOR_BILL_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_APPROVE_VENDOR_BILL_FAILURE, message: e?.message });
    }
}

function* payVendorBill(action) {
    try {
        const result = yield call(req.payVendorBillReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_PAY_VENDOR_BILL_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_PAY_VENDOR_BILL_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_PAY_VENDOR_BILL_FAILURE, message: e?.message });
    }
}

// ============ VENDOR BANK ACCOUNTS ============

function* getVendorBankAccounts(action) {
    try {
        const result = yield call(req.getVendorBankAccountsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_BANK_ACCOUNTS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_BANK_ACCOUNTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_BANK_ACCOUNTS_FAILURE, message: e?.message });
    }
}

function* createVendorBankAccount(action) {
    try {
        const result = yield call(req.createVendorBankAccountReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_FAILURE, message: e?.message });
    }
}

function* updateVendorBankAccount(action) {
    try {
        const result = yield call(req.updateVendorBankAccountReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_FAILURE, message: e?.message });
    }
}

function* deleteVendorBankAccount(action) {
    try {
        const result = yield call(req.deleteVendorBankAccountReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_FAILURE, message: e?.message });
    }
}

// ============ VENDOR AMC TRACKER ============

function* getVendorAmcList(action) {
    try {
        const result = yield call(req.getVendorAmcListReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_AMC_LIST_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_AMC_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_AMC_LIST_FAILURE, message: e?.message });
    }
}

function* getVendorAmcDetails(action) {
    try {
        const result = yield call(req.getVendorAmcDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_AMC_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_AMC_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_AMC_DETAILS_FAILURE, message: e?.message });
    }
}

function* createVendorAmc(action) {
    try {
        const result = yield call(req.createVendorAmcReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_AMC_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_AMC_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_CREATE_VENDOR_AMC_FAILURE, message: e?.message });
    }
}

function* updateVendorAmc(action) {
    try {
        const result = yield call(req.updateVendorAmcReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_AMC_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_AMC_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_UPDATE_VENDOR_AMC_FAILURE, message: e?.message });
    }
}

function* deleteVendorAmc(action) {
    try {
        const result = yield call(req.deleteVendorAmcReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_AMC_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_AMC_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_DELETE_VENDOR_AMC_FAILURE, message: e?.message });
    }
}

// ============ VENDOR GL CODES ============

function* getVendorGlCodes(action) {
    try {
        const result = yield call(req.getVendorGlCodesReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_GL_CODES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_GL_CODES_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_GL_CODES_FAILURE, message: e?.message });
    }
}

// ============ VENDOR GL CODE DROPDOWN ============

function* getVendorGlCodeDropdown(action) {
    try {
        const result = yield call(req.getVendorGlCodeDropdownReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_FAILURE, message: e?.message });
    }
}

// ============ VENDOR ROUND OFF GL CODE ============

function* getVendorRoundOffGl(action) {
    try {
        const result = yield call(req.getVendorRoundOffGlReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_ROUND_OFF_GL_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_ROUND_OFF_GL_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_ROUND_OFF_GL_FAILURE, message: e?.message });
    }
}

// ============ VENDOR BILLING SETTINGS ============

function* getVendorBillingSettings(action) {
    try {
        const result = yield call(req.getVendorBillingSettingsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_BILLING_SETTINGS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_BILLING_SETTINGS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_BILLING_SETTINGS_FAILURE, message: e?.message });
    }
}

function* saveVendorBillingSettings(action) {
    try {
        const result = yield call(req.saveVendorBillingSettingsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_FAILURE, message: e?.message });
    }
}

function* getVendorsDropdown(action) {
    try {
        const result = yield call(req.getVendorsDropdownReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDORS_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDORS_DROPDOWN_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDORS_DROPDOWN_FAILURE, message: e?.message });
    }
}

// ============ VENDOR PAYMENTS ============

function* getVendorPaymentsList(action) {
    try {
        const result = yield call(req.getVendorPaymentsListReq, action);
        if (result.success === true) {
            yield put({
                type: types.SOCIETY_GET_VENDOR_PAYMENTS_LIST_SUCCESS,
                payload: { data: result.data, meta: result.meta },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_PAYMENTS_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_PAYMENTS_LIST_FAILURE, message: e?.message });
    }
}

function* getVendorPaymentDetails(action) {
    try {
        const result = yield call(req.getVendorPaymentDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_PAYMENT_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_PAYMENT_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_PAYMENT_DETAILS_FAILURE, message: e?.message });
    }
}

function* createVendorPayment(action) {
    try {
        const result = yield call(req.createVendorPaymentReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_PAYMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VENDOR_PAYMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_CREATE_VENDOR_PAYMENT_FAILURE, message: e?.message });
    }
}

function* updateVendorPayment(action) {
    try {
        const result = yield call(req.updateVendorPaymentReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_PAYMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_VENDOR_PAYMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_UPDATE_VENDOR_PAYMENT_FAILURE, message: e?.message });
    }
}

function* deleteVendorPayment(action) {
    try {
        const result = yield call(req.deleteVendorPaymentReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_PAYMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VENDOR_PAYMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_DELETE_VENDOR_PAYMENT_FAILURE, message: e?.message });
    }
}

function* getVendorUnpaidBills(action) {
    try {
        const result = yield call(req.getVendorUnpaidBillsReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_VENDOR_UNPAID_BILLS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VENDOR_UNPAID_BILLS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_VENDOR_UNPAID_BILLS_FAILURE, message: e?.message });
    }
}

// Vendor bulk Excel upload — pushes both the response summary and any
// caller-supplied onSuccess / onError callbacks. The reducer stores the
// summary so the FE results modal can render created/failed lists.
function* bulkUploadVendors(action) {
    try {
        const result = yield call(req.bulkUploadVendorsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDORS_SUCCESS, payload: result.data, message: result.message });
            if (action?.data?.onSuccess) action.data.onSuccess(result.data);
        } else {
            const msg = result?.response?.data?.message || result?.message || 'Bulk upload failed';
            yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDORS_FAILURE, message: msg });
            if (action?.data?.onError) action.data.onError(result);
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDORS_FAILURE, message: e?.message });
        if (action?.data?.onError) action.data.onError(e);
    }
}

// Vendor bill bulk Excel upload — same shape as vendors above.
function* bulkUploadVendorBills(action) {
    try {
        const result = yield call(req.bulkUploadVendorBillsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDOR_BILLS_SUCCESS, payload: result.data, message: result.message });
            if (action?.data?.onSuccess) action.data.onSuccess(result.data);
        } else {
            const msg = result?.response?.data?.message || result?.message || 'Bulk upload failed';
            yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDOR_BILLS_FAILURE, message: msg });
            if (action?.data?.onError) action.data.onError(result);
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDOR_BILLS_FAILURE, message: e?.message });
        if (action?.data?.onError) action.data.onError(e);
    }
}

// Vendor payment bulk Excel upload — same shape.
function* bulkUploadVendorPayments(action) {
    try {
        const result = yield call(req.bulkUploadVendorPaymentsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_SUCCESS, payload: result.data, message: result.message });
            if (action?.data?.onSuccess) action.data.onSuccess(result.data);
        } else {
            const msg = result?.response?.data?.message || result?.message || 'Bulk upload failed';
            yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_FAILURE, message: msg });
            if (action?.data?.onError) action.data.onError(result);
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_FAILURE, message: e?.message });
        if (action?.data?.onError) action.data.onError(e);
    }
}

export default function* vendorSaga() {
    yield takeLatest(types.SOCIETY_GET_VENDOR_CATEGORIES, getVendorCategories);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR_CATEGORY, createVendorCategory);
    yield takeLatest(types.SOCIETY_UPDATE_VENDOR_CATEGORY, updateVendorCategory);
    yield takeLatest(types.SOCIETY_DELETE_VENDOR_CATEGORY, deleteVendorCategory);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR, createVendor);
    yield takeLatest(types.SOCIETY_GET_VENDOR_DETAILS, getVendorDetails);
    yield takeLatest(types.SOCIETY_GET_VENDORS_LIST, getVendorsList);
    yield takeLatest(types.SOCIETY_UPDATE_VENDOR, updateVendor);
    yield takeLatest(types.SOCIETY_DELETE_VENDOR, deleteVendor);
    yield takeLatest(types.SOCIETY_GET_ALL_VENDORS, getAllVendors);
    // Vendor Setting
    yield takeLatest(types.SOCIETY_GET_VENDOR_SETTING, getVendorSetting);
    // Vendor Tariffs
    yield takeLatest(types.SOCIETY_GET_VENDOR_TARIFFS, getVendorTariffs);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR_TARIFF, createVendorTariff);
    yield takeLatest(types.SOCIETY_DELETE_VENDOR_TARIFF, deleteVendorTariff);
    yield takeLatest(types.SOCIETY_GET_ALL_VENDOR_TARIFFS, getAllVendorTariffs);
    // Vendor Bills
    yield takeLatest(types.SOCIETY_GET_VENDOR_BILLS_LIST, getVendorBillsList);
    yield takeLatest(types.SOCIETY_GET_VENDOR_BILL_DETAILS, getVendorBillDetails);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR_BILL, createVendorBill);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR_BILLS_BATCH, createVendorBillsBatch);
    yield takeLatest(types.SOCIETY_UPDATE_VENDOR_BILL, updateVendorBill);
    yield takeLatest(types.SOCIETY_DELETE_VENDOR_BILL, deleteVendorBill);
    yield takeLatest(types.SOCIETY_APPROVE_VENDOR_BILL, approveVendorBill);
    yield takeLatest(types.SOCIETY_PAY_VENDOR_BILL, payVendorBill);
    // Vendor Bank Accounts
    yield takeLatest(types.SOCIETY_GET_VENDOR_BANK_ACCOUNTS, getVendorBankAccounts);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT, createVendorBankAccount);
    yield takeLatest(types.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT, updateVendorBankAccount);
    yield takeLatest(types.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT, deleteVendorBankAccount);
    // Vendor AMC Tracker
    yield takeLatest(types.SOCIETY_GET_VENDOR_AMC_LIST, getVendorAmcList);
    yield takeLatest(types.SOCIETY_GET_VENDOR_AMC_DETAILS, getVendorAmcDetails);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR_AMC, createVendorAmc);
    yield takeLatest(types.SOCIETY_UPDATE_VENDOR_AMC, updateVendorAmc);
    yield takeLatest(types.SOCIETY_DELETE_VENDOR_AMC, deleteVendorAmc);
    // Vendor GL Codes
    yield takeLatest(types.SOCIETY_GET_VENDOR_GL_CODES, getVendorGlCodes);
    yield takeLatest(types.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN, getVendorGlCodeDropdown);
    // Vendor Round Off GL Code
    yield takeLatest(types.SOCIETY_GET_VENDOR_ROUND_OFF_GL, getVendorRoundOffGl);
    // Vendor Billing Settings
    yield takeLatest(types.SOCIETY_GET_VENDOR_BILLING_SETTINGS, getVendorBillingSettings);
    yield takeLatest(types.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS, saveVendorBillingSettings);
    yield takeLatest(types.SOCIETY_GET_VENDORS_DROPDOWN, getVendorsDropdown);
    // Vendor Payments
    yield takeLatest(types.SOCIETY_GET_VENDOR_PAYMENTS_LIST, getVendorPaymentsList);
    yield takeLatest(types.SOCIETY_GET_VENDOR_PAYMENT_DETAILS, getVendorPaymentDetails);
    yield takeLatest(types.SOCIETY_CREATE_VENDOR_PAYMENT, createVendorPayment);
    yield takeLatest(types.SOCIETY_UPDATE_VENDOR_PAYMENT, updateVendorPayment);
    yield takeLatest(types.SOCIETY_DELETE_VENDOR_PAYMENT, deleteVendorPayment);
    yield takeLatest(types.SOCIETY_GET_VENDOR_UNPAID_BILLS, getVendorUnpaidBills);
    // Vendor bulk Excel upload
    yield takeLatest(types.SOCIETY_BULK_UPLOAD_VENDORS, bulkUploadVendors);
    yield takeLatest(types.SOCIETY_BULK_UPLOAD_VENDOR_BILLS, bulkUploadVendorBills);
    yield takeLatest(types.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS, bulkUploadVendorPayments);
}
